import { render, staticRenderFns } from "./ShiftItem.vue?vue&type=template&id=4fcedae6&scoped=true&"
import script from "./ShiftItem.vue?vue&type=script&lang=js&"
export * from "./ShiftItem.vue?vue&type=script&lang=js&"
import style0 from "./ShiftItem.vue?vue&type=style&index=0&id=4fcedae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcedae6",
  null
  
)

export default component.exports